import { Button, Space } from "antd";
import { useState } from "react";
import color from "../../../theme/color";
import { ArrowSmallLeft, GhostReload } from "../Icon";
import { IconForm } from "../Icon/index.styled";

interface FilterExtraBtnCompProps {
  // 확장여부
  expand?: boolean;
  // 새로고침 버튼 클릭 이벤트 - 없으면 버튼 숨김
  onReload?: () => void;
  // 확정 버튼 클릭 이벤트 - 없으면 버튼 숨김
  onExpand?: (expand?: boolean) => void;
  // 검색 버튼 클릭 이벤트 - 없으면 버튼 숨김
  onSearch?: () => void;
}

/**
 * 필터 버튼 모음
 * 초기화 | 확정 | 검색
 * @returns
 */
export const FilterExtraBtnComp: React.FC<FilterExtraBtnCompProps> = ({
  expand = false,
  onExpand,
  onReload,
  onSearch,
}) => {
  const [visible, setVisible] = useState(expand);

  return (
    <Space size={8}>
      {onReload && (
        <Button
          type="default"
          ghost
          icon={
            <IconForm
              component={GhostReload}
              color={color.gray4}
              style={{ fontSize: 18 }}
            />
          }
          onClick={onReload}
        />
      )}
      {onExpand && (
        <Button
          type="default"
          ghost
          icon={
            <IconForm
              component={ArrowSmallLeft}
              color={color.gray4}
              style={{ fontSize: 12 }}
              rotate={visible ? 90 : 270}
            />
          }
          onClick={() => {
            const val = !visible;
            setVisible(val);
            onExpand(val);
          }}
        />
      )}
      {onSearch && (
        <Button type="primary" onClick={onSearch}>
          검색
        </Button>
      )}
    </Space>
  );
};
